module.exports = __webpack_public_path__ + "static/media/5-STAR_logo.e4301fdd.jpg";